import { InputHTMLAttributes, ReactNode } from "react";
import styled from "styled-components";

type RadioProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
};

const RadioButton = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
`;

const StyledRadio = styled.div`
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #ccc;
  position: relative;
  flex-shrink: 0;

  ${HiddenRadio}:checked + & {
    background-color: white;
    border-color: var(--palette-primary-default);

    ::after {
      content: "";
      position: absolute;
      inset: 2px;
      border-radius: 50%;
      background-color: var(--palette-primary-default);
    }
  }
`;

export const Radio = ({ label, ...rest }: RadioProps) => {
  return (
    <RadioButton>
      <HiddenRadio type="radio" {...rest} />
      <StyledRadio />
      {label}
    </RadioButton>
  );
};
